// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"346":"ReferralsPage","375":"BuyBoxPage","789":"LoginPage","824":"FAQPage"}[chunkId] + "." + {"346":"049702a9","375":"3fae135d","789":"fa5e9664","824":"cf0b2c8a"}[chunkId] + ".chunk.css";
};